import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 0.7;
  }
`;

export const IconWrapper = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;

export const CheckmarkIcon = styled.svg`
  width: 18px;
  height: 18px;
  animation: ${fadeIn} 0.3s ease-out;
  
  circle {
    fill: #00aa00;
  }
  
  path {
    stroke: white;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
  }
`;

export const SpinnerIcon = styled.svg`
  width: 18px;
  height: 18px;
  animation: ${spin} 1s linear infinite;
  
  circle {
    stroke: #0066cc;
    stroke-width: 2;
    fill: none;
    stroke-dasharray: 40;
    stroke-dashoffset: 10;
    stroke-linecap: round;
  }
`;

export const PendingDot = styled.span<{ $required?: boolean }>`
  width: ${(props) => (props.$required ? "10px" : "6px")};
  height: ${(props) => (props.$required ? "10px" : "6px")};
  border-radius: 50%;
  background-color: #ccc;
  animation: ${pulse} 2s ease-in-out infinite;
`;

export const LoadingHighlight = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(0, 102, 204, 0.05) 50%,
    transparent 100%
  );
  animation: ${keyframes`
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  `} 1.5s ease-in-out infinite;
  pointer-events: none;
  border-radius: 8px;
`;
